<template>
  <v-card>
    <v-card-title class="headline py-2">
      Создать компанию
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field 
          label="Название компании" 
          v-model="companyName"
          :rules="[v => !!v || 'Необходимо ввести название компании']"
          required />
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="createCompany" :loading="saving" :disabled="!valid || saving || status.btnDisabled">Создать</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
import apiAccount from "../../../api"

export default {
  name : 'NewCompanyForm',
  
  data() {
    return {
      companyName: '',
      saving: false,
      loader: null,
      valid: true,
      status:{
        btnDisabled: false,
        text: '',
        className:'success--text darken-1'
      },
    }
  },
  
  methods : {
    createCompany() {
      if (this.$refs.form.validate()) {
        this.saving = true

        apiAccount.createCompany({ name: this.companyName }).then( response => {
          this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
          this.$dmsSuccessNoty('Компания успешно создана')
          this.$emit('save', response.company)
        }).catch( error => {
          let errmessage = (error.response) ? error.response.data.error : 'Ошибка создания'
          this.status={ btnDisabled: false, text: errmessage, className:'error--text darken-1' }
        }).finally(() => {
          this.saving = false
          l
        })

      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/account/components/Account/Forms/NewCompanyForm.vue